import React, { useState, useEffect, useRef } from 'react';
import './Study.css';
import $ from 'jquery';
import JSPath from 'jspath';
import { Button } from "reactstrap";
import Footer from '../Footer/Footer';
import parse from 'html-react-parser';
import Header from '../Header/Header';
import { BiMove } from "react-icons/bi";
import Spinner from '../Spinner/Spinner';
import { withRouter } from "react-router";
import { post } from '../../app/shared/http';
import { withAuth } from "../../app/util/HOC";
import { Editor } from "@tinymce/tinymce-react";
import StudyCenterHeader from './StudyCenterHeader';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import { makeStyles } from '@material-ui/core/styles';
import { handleException } from "../../app/util/util";
import loaderColors1 from '../Spinner/loaderColors1.gif';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import { usePagination } from '@material-ui/lab/Pagination';
import { Typography, Popper, Fade, Paper } from '@material-ui/core';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
let globalData = {}, issueSpottedId = 0, qList = [], eleAnchor = "", subQList = [];
let numberToCharacterMap = {
    '1': 'a', '2': 'b', '3': 'c', '4': 'd', '5': 'e', '6': 'f', '7': 'g', '8': 'h', '9': 'i', '10': 'j', '11': 'k', '12': 'l', '13': 'm',
    '14': 'n', '15': 'o', '16': 'p', '17': 'q', '18': 'r', '19': 's', '20': 't', '21': 'u', '22': 'v', '23': 'w', '24': 'x', '25': 'y', '26': 'z'
};
const useStyles = makeStyles((theme) => ({
    root: {
        width: 500,
    },
    ul: {
        listStyle: 'none',
        padding: 0,
        margin: 0,
        display: 'flex',
    },
}));
export function StudyIssueSpotStudent(props) {
    const userVO = JSON.parse(localStorage.getItem('userVO'));
    const keepMeLogIn = localStorage.getItem('keepLoggedIn') ? "true" : "false";
    const [bookVO, setBookVO] = useState(JSON.parse(localStorage.getItem('bookVO')));
    const [currentQuestion, setCurrentQuestion] = useState(null);
    const [btnFlagText, setbtnFlagText] = useState("Flag For Later");
    const [questionBankVOList, setQuestionBankVOList] = useState(null);
    const [totalQuestionCount, setTotalQuestionCount] = useState(0);
    const [loName, setLoName] = useState("");
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState("");
    const [issueOptions, setIssueOptions] = useState([]);
    const [issueText, setIssueText] = useState("");
    const [issueSpotTiny, setIssueSpotTiny] = useState("");
    const [issueFeedback, setIssueFeedback] = useState("");
    const [issueNextBtn, setIssueNextBtn] = useState(false);
    const [subAnswerVOList, setSubAnswerVOList] = useState([]);
    const [essayText, setEssayText] = useState("");
    const [issueOrder, setIssueOrder] = useState(false);
    const [issueEssay, setIssueEssay] = useState(false);
    const [showSubmitBtn, setShowSubmitBtn] = useState(false);
    const [showissueEssay, setShowissueEssay] = useState(false);
    const [essayAnswer, setEssayAnswer] = useState("");
    const [generalFeedback, setGeneralFeedback] = useState("");
    const [isloading, setisLoading] = useState(false);
    const [practicebtn, setpracticebtn] = useState(false);
    const [correctbtn, setcorrectbtn] = useState(false);
    const [incorrectbtn, setincorrectbtn] = useState(false);
    const classes = useStyles();
    const editorRef = useRef(null);
    useEffect(() => {
        async function fetchQuestions() {
            let reqData = {
                "userVO": {
                    "userId": userVO.userId,
                    "userActivityVO": {
                        "lastActivityCode": "BOOKSHELF",
                        "pageNavigatingFrom": "BOOKSHELF",
                        "pageNavigatingTo": "BOOKSHELF",
                    },
                    sessionVO: {
                        "appType": "web",
                        "browserName": localStorage.getItem('browserName'),
                        "deviceMacId": "",
                        "deviceOS": localStorage.getItem('deviceOS'),
                        "deviceType": localStorage.getItem('deviceType'),
                        "keepMeLoggedInFlag": keepMeLogIn,
                        "sessionAuthenticationToken": userVO.sessionAuthenticationToken,
                    },
                    "userRole": userVO.userRole,
                    "userRoleId": userVO.userRoleId,
                },
                "bookVO": {
                    "bookISBN": props.match.params.isbn
                },
                "questionVO": {
                    "questionType": "issuespotting",
                    "classId": -999,
                    "chapterId": props.match.params.chapterid,
                    "learningObjectId": props.match.params.loid,
                    "bookISBN": props.match.params.isbn
                }
            }
            const requestOptions1 = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify(reqData)
            };
            setisLoading(true);
            fetch(localStorage.getItem('ENV') + "/assessmentRetrievalService/getQuestionForStudyCenterLearnRv", requestOptions1)
                .then(response => response.json())
                .then(data => {
                    if (data) {
                        if (data.status === "true") {
                            let loName = data.learningObjName;
                            if (data.assessmentVO && data.assessmentVO.questionBankVOList) {
                                if (data.assessmentVO.questionBankVOList) {
                                    data.bookVO.chapterId = props.match.params.chapterid;
                                    data.assessmentVO.questionBankVOList = Array.isArray(data.assessmentVO.questionBankVOList) ? data.assessmentVO.questionBankVOList :
                                        [data.assessmentVO.questionBankVOList]
                                    if (data.assessmentVO.questionBankVOList[0].questionResponseVO.status == "correct") {
                                        setpracticebtn(false);
                                        setincorrectbtn(false);
                                        setcorrectbtn(true);
                                    }
                                    else if (data.assessmentVO.questionBankVOList[0].questionResponseVO.status == "incorrect") {
                                        setpracticebtn(false);
                                        setincorrectbtn(true);
                                        setcorrectbtn(false);
                                    }
                                    else if (data.assessmentVO.questionBankVOList[0].questionResponseVO.status == "partial") {
                                        setpracticebtn(true);
                                        setincorrectbtn(false);
                                        setcorrectbtn(false);
                                    } else {
                                        setpracticebtn(false);
                                        setincorrectbtn(false);
                                        setcorrectbtn(false);
                                    }
                                    let flag = 0;
                                    for (let i = 0; i < data.assessmentVO.questionBankVOList.length; i++) {
                                        if (data.assessmentVO.questionBankVOList[i].questionResponseVO.status === "not attempted") {
                                            flag = 1;
                                            setTotalQuestionCount(data.assessmentVO.countOfTotalQuestion);
                                            setQuestionBankVOList(data.assessmentVO.questionBankVOList);
                                            setCurrentQuestion(data.assessmentVO.questionBankVOList[i]);
                                            data.assessmentVO.questionBankVOList[i].questionVO.subQuestionVOList.map((it, index) => {
                                                if (it.questionType === "order") {
                                                    setSubAnswerVOList(it.subAnswerVOList);
                                                }
                                                else if (it.questionType === "essay") {
                                                    setEssayText(it.questionText);
                                                    setGeneralFeedback(it.generalFeedback);
                                                }
                                            });
                                            setBookVO(data.bookVO);
                                            setLoName(loName);
                                            getAttemptedIssueSpotting(data.assessmentVO.questionBankVOList[i]);
                                            updateCurrentQuestionBtn(i + 1);
                                            /*CC-5614  -  for question which are not attempted - reset the myKnowledge button */
                                            setpracticebtn(false);
                                            setincorrectbtn(false);
                                            setcorrectbtn(false);
                                            break;
                                        }
                                    }
                                    if (flag === 0) {
                                        setTotalQuestionCount(data.assessmentVO.countOfTotalQuestion);
                                        setQuestionBankVOList(data.assessmentVO.questionBankVOList);
                                        setCurrentQuestion(data.assessmentVO.questionBankVOList[0]);
                                        data.assessmentVO.questionBankVOList[0].questionVO.subQuestionVOList.map((it, index) => {
                                            if (it.questionType === "order") {
                                                setSubAnswerVOList(it.subAnswerVOList);
                                            }
                                            else if (it.questionType === "essay") {
                                                setShowissueEssay(true);
                                                setEssayText(it.questionText);
                                                setGeneralFeedback(it.generalFeedback);
                                            }
                                        });
                                        setBookVO(data.bookVO);
                                        setLoName(loName);
                                        getAttemptedIssueSpotting(data.assessmentVO.questionBankVOList[0]);
                                        updateCurrentQuestionBtn(1);
                                        setisLoading(false);
                                    }
                                }
                                else
                                    setLoName(loName);
                                setisLoading(false);
                            }
                            else
                                setLoName(loName);
                            setisLoading(false);
                            let questionList = data.assessmentVO.questionBankVOList;
                            let questionType = questionList[0].questionVO.questionType;
                            let totalQuestion = data.assessmentVO.countOfTotalQuestion;
                            questionList.totalQuestion = totalQuestion;
                            let questionNum = JSPath.apply('.{.currentQuestionFlag == "1"}.questionNumber', questionList);
                            if (Array.isArray(questionNum) && questionNum.length == 0) {
                                questionNum = 1;
                            }
                            for (let i = 0; i < questionList.length; i++) {
                                questionList[i].totalQuestion = totalQuestion;
                                questionType = questionList[i].questionVO.questionType;
                                if (typeof (questionList[i].questionVO.studyAidVOList) == 'object') {
                                    questionList[i].questionVO.studyAidVOList = [questionList[i].questionVO.studyAidVOList];
                                }
                                if (typeof (questionList[i].questionVO.studyReferenceVOList) == 'object') {
                                    questionList[i].questionVO.studyReferenceVOList = [questionList[i].questionVO.studyReferenceVOList];
                                }
                            }
                            globalData = questionList;
                            // [HS]Issue Spotting - when the question is answred - dont show popover questions
                            if (data.assessmentVO.questionBankVOList[0].questionResponseVO.attemptedAnswerVOList === null || data.assessmentVO.questionBankVOList[0].questionResponseVO.attemptedAnswerVOList === undefined) {
                                let issueToHighlight = $('#issueContainer span.issue').first();
                                highlightIssue(issueToHighlight);
                            }
                        } else {
                            if (data.wkErrorCode) {
                                handleException(data);
                            }
                        }
                    }
                }).catch(error => {
                    console.error("There has been a problem with your fetch operation:", error)
                    setisLoading(false);
                });
        }
        fetchQuestions();
    }, []);
    const handleEditorChange = (e) => {
        if (editorRef.current.getBody().innerHTML.trim() !== "")
            setShowSubmitBtn(true);
        else
            setShowSubmitBtn(false);
    }
    const navigateToStudyDashboard = (e) => {
        props.history.push(`/study/${props.match.params.isbn}/${props.match.params.chapterid}`);
    }
    const getAttemptedIssueSpotting = (currQuestion) => {
        if (currQuestion.questionResponseVO.attemptedAnswerVOList) {
            let givenAnswerEssay = currQuestion.questionResponseVO.attemptedAnswerVOList.responseText;
            givenAnswerEssay = givenAnswerEssay !== "" ? givenAnswerEssay.split("|||||")[1] : givenAnswerEssay;
            setIssueSpotTiny(givenAnswerEssay);
            setEssayAnswer((givenAnswerEssay == undefined ? "" : givenAnswerEssay));
            setShowissueEssay(true);
            if (editorRef !== null && editorRef.current !== null && editorRef.current.getBody() !== null)
                editorRef.current.getBody().innerHTML = givenAnswerEssay;
        }
        else {
            if (editorRef !== null && editorRef.current !== null && editorRef.current.getBody() !== null)
                editorRef.current.getBody().innerHTML = "";
            setIssueSpotTiny("");
            setEssayAnswer("");
            setShowissueEssay(false);
        }
    }
    const highlightIssue = (issueToHighlight) => {
        setIssueText("");
        setIssueOptions([]);
        setIsPopoverOpen(false);
        setAnchorEl("");
        setIssueNextBtn(false);
        let removeDisabled = document.querySelectorAll('input[name="optionsRadios"]'), i;
        for (i = 0; i < removeDisabled.length; i++) {
            document.getElementById('optionsRadios' + i).removeAttribute('disabled');
            let j = document.getElementById('optionsRadios' + i).parentNode.style.removeProperty('font-weight');
            document.getElementById('optionsRadios' + i).checked = false;
        }
        let $this = issueToHighlight;
        $this.addClass('highlight issueVisited');
        let id = $this.attr('id');
        eleAnchor = document.querySelector('.issue.highlight.issueVisited');
        issueSpottedId = id;
        let question = {};
        let questionList = [];
        if (qList.length > 0) {
            questionList = qList;
        } else {
            questionList = JSPath.apply('.{.currentQuestionFlag == "1"}.questionVO.subQuestionVOList.{.subAnswerVOList.spanId == "' + id + '"}', globalData);
        }
        if (questionList.length > 0) {
            question = questionList[0];
            if (questionList.length > 1) {
                questionList.splice(0, 1);
                qList = questionList;
            } else {
                qList = [];
            }
        }
        let issueText = '<div id="issueText">' + question.questionText + '</div><div className="clear" style="padding: 0 0 10px;"></div>';
        let issueMCQAnswerList = question.subAnswerVOList.issueMCQAnswerList;
        let issueOptions = issueMCQAnswerList;
        let feedback = '';
        let container = '';
        feedback += '<div id="feedback"></div>';
        setIssueFeedback("");
        setIssueText(issueText);
        setIssueOptions(issueOptions);
        setIsPopoverOpen(true);
        setAnchorEl(eleAnchor);
    }
    const issueSpotSubmit = (e) => {
        let subQuestionList = [];
        let subQuestion = {};
        if (subQList.length > 0) {
            subQuestionList = subQList;
        } else {
            subQuestionList = JSPath.apply('.{.currentQuestionFlag == "1"}.questionVO.subQuestionVOList{.subAnswerVOList.spanId == "' + issueSpottedId + '"}', globalData);
        }
        if (subQuestionList.length > 0) {
            subQuestion = subQuestionList[0];
        }
        let issueMCQAnswerList = subQuestion.subAnswerVOList.issueMCQAnswerList;
        let optionSelectedVal = $('input:radio[name="optionsRadios"]:checked').val();
        for (let i = 0; i < issueMCQAnswerList.length; i++) {
            if (i == optionSelectedVal) {
                if (parseInt(issueMCQAnswerList[i].fraction) == 1) {
                    if (subQuestionList.length > 1) {
                        subQuestionList.splice(0, 1);
                        subQList = subQuestionList;
                    } else {
                        subQList = [];
                    }
                    $('input:radio[name="optionsRadios"]').parent().addClass('disableLabel');
                    $('input:radio[name="optionsRadios"]').attr('disabled', 'disabled');
                    $('input:radio[name="optionsRadios"][value="' + i + '"]').parent().removeClass('disableLabel');
                    $('input:radio[name="optionsRadios"][value="' + i + '"]').parent()[0].style.cssText = 'font-weight:bold !important';
                    let subAnswer = subQuestion.subAnswerVOList;
                    let issueOrder = subAnswer.issueOrder;
                    if (!Array.isArray(issueOrder)) {
                        issueOrder = [issueOrder];
                    }
                    let orderList = JSPath.apply('.{.currentQuestionFlag == "1"}.questionVO.subQuestionVOList.{.questionType == "order"}', globalData)[0].subAnswerVOList;
                    let issueSpotted = [];
                    for (let j = 0; j < issueOrder.length; j++) {
                        for (let k = 0; k < orderList.length; k++) {
                            if (issueOrder[j] == orderList[k].issueId) {
                                issueSpotted.push(orderList[k].issueText);
                                if ($('#issueOrderContainer ul.sortable > li[issueid="' + orderList[k].issueId + '"]').length == 0) {
                                    let $li = '';
                                    if (orderList.length == 1) {
                                        $li = $('<li className="issue-list-item" tabindex="0" issueid="' + orderList[k].issueId + '" correctorder="' + orderList[k].correctOrder + '"><span className="arrange-issue"><span className="text-lable">' + orderList[k].issueText + '</span></span></li>');
                                    } else {
                                        $li = $('<li className="issue-list-item" tabindex="0" issueid="' + orderList[k].issueId + '" correctorder="' + orderList[k].correctOrder + '"><button type="button" tabindex="0" className="uparrow" onClick="swapWithPrev(this);" ontouchstart="swapWithPrev(this);"></button><span className="arrange-issue"><span className="text-lable">' + orderList[k].issueText + '</span></span><button type="button" tabindex="0" className="downarrow" onClick="swapWithNext(this);" ontouchstart="swapWithNext(this);"></button></li>');
                                    }
                                    $('#issueOrderContainer ul.sortable').append($li);
                                }
                                break;
                            }
                        }
                    }
                    if (issueOrder.length > 1) {
                        setIssueFeedback(
                            '<span><i className="far fa-check-circle" style="color: #85BC20"></i>' +
                            " Issues Spotted:" + issueSpotted.join(', ') + '</span>');
                    } else {
                        if ($.trim(issueSpotted.join(', ')) != '') {
                            setIssueFeedback('<span><i className="far fa-check-circle" style="color: #85BC20"></i>' + " Issue Spotted: " + issueSpotted.join(', ') + '</span>');
                        } else {
                            setIssueFeedback('<span><i className="far fa-check-circle" style="color: #85BC20"></i>' + " No issues here.");
                        }
                    }
                    setIssueNextBtn(true);
                } else {
                    setIssueFeedback('<span><i className="far fa-times-circle" style="color: #E5202E"></i>' + " Incorrect, try again.");
                }
            }
        }
    }
    const handleNextClick = (e) => {
        let orderList = JSPath.apply('.{.currentQuestionFlag == "1"}.questionVO.subQuestionVOList.{.questionType == "order"}', globalData)[0].subAnswerVOList;
        if (qList.length > 0) {
            setIsPopoverOpen(false);
            let issueToHighlight = $('#issueContainer span.issue.highlight');
            highlightIssue(issueToHighlight);
        } else {
            setIsPopoverOpen(false);
            if ($('#issueContainer span.issue:not(.issueVisited)').first().length > 0) {
                let issueToHighlight = $('#issueContainer span.issue:not(.issueVisited)').first();
                $('#issueContainer span.issue.highlight').removeClass('highlight');
                highlightIssue(issueToHighlight);
            } else {
                $('#issueContainer span.issue.highlight').removeClass('highlight');
                setIssueOrder(true);
                setIssueEssay(true);
            }
        }
    }
    const submitAnswerShortAnswer = (e, value) => {
        let issueOrderList = document.querySelector("#issueOrder .labelVOList").childNodes, issueUserOrder = "";
        issueOrderList.forEach(function (item, index) {
            let issueOrderEle = item.childNodes;
            issueOrderEle.forEach(function (item1, index1) {
                issueUserOrder += item1.getAttribute('correctorder');
                if (issueOrderList.length - 1 !== index) { issueUserOrder += ","; }
            });
        });
        let reqData = {
            "userVO": {
                "userId": userVO.userId,
                "userActivityVO": {
                    "lastActivityCode": "BOOKSHELF",
                    "pageNavigatingFrom": "BOOKSHELF",
                    "pageNavigatingTo": "BOOKSHELF",
                },
                sessionVO: {
                    "appType": "web",
                    "browserName": localStorage.getItem('browserName'),
                    "deviceMacId": "",
                    "deviceOS": localStorage.getItem('deviceOS'),
                    "deviceType": localStorage.getItem('deviceType'),
                    "keepMeLoggedInFlag": keepMeLogIn,
                    "sessionAuthenticationToken": userVO.sessionAuthenticationToken,
                },
                "userRole": userVO.userRole,
                "userRoleId": userVO.userRoleId,
            },
            "assessmentVO": {
                "questionVO": {
                    "answerVOList": [{
                        "questionId": currentQuestion.questionVO.questionId,
                        "responseText": issueUserOrder + "|||||" + editorRef.current.getBody().innerHTML
                    }],
                    "saveFlag": value === "save" ? 1 : 0,
                }
            }
        }
        const requestOptions1 = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(reqData)
        };
        fetch(localStorage.getItem('ENV') + "/manageAssessmentService/submitQuestionResponse", requestOptions1)
            .then(response => response.json())
            .then(data => {
                if (data) {
                    if (data.status === "true") {
                        if (value === "submit") {
                            if (questionBankVOList) {
                                if (questionBankVOList[currentQuestion.questionNumber - 1]) {
                                    var tempQuestionBankVOList = questionBankVOList
                                    var attemptedAnswerVOList = { "responseText": editorRef.current.getBody() ? editorRef.current.getBody().innerHTML : "" }
                                    tempQuestionBankVOList[currentQuestion.questionNumber - 1].questionResponseVO.attemptedAnswerVOList = attemptedAnswerVOList;
                                    if (value === "submit") {
                                        tempQuestionBankVOList[currentQuestion.questionNumber - 1].questionResponseVO.status = "answered"
                                        setEssayAnswer(editorRef.current.getBody() ? editorRef.current.getBody().innerHTML : "");
                                        setIssueEssay(false);
                                        setShowSubmitBtn(false);
                                        setShowissueEssay(true);
                                        setQuestionBankVOList(tempQuestionBankVOList);
                                    }
                                } else {
                                    setEssayAnswer(editorRef.current.getBody() ? editorRef.current.getBody().innerHTML : "");
                                    setIssueEssay(false);
                                    setShowSubmitBtn(false);
                                    setShowissueEssay(true);
                                }
                            } else {
                                setEssayAnswer(editorRef.current.getBody() ? editorRef.current.getBody().innerHTML : "");
                                setIssueEssay(false);
                                setShowSubmitBtn(false);
                                setShowissueEssay(true);
                            }
                        }
                    } else if (data.wkErrorCode) {
                        handleException(data);
                    }
                }
            });
    }
    const getQuestion = (e, type) => {
        setIssueText("");
        setIssueOptions([]);
        setIsPopoverOpen(false);
        setAnchorEl("");
        setIssueNextBtn(false);
        setIssueOrder(false);
        setIssueEssay(false);
        setSubAnswerVOList([]);
        setEssayText("");
        setGeneralFeedback("");
        if(parseInt(totalQuestionCount - 1) === parseInt(e.target.getAttribute("arrayIndex"))){
            document.getElementById(`btnQuestion_${parseInt(currentQuestion.questionNumber) + 1}`).focus();
         }
        if (e.target.getAttribute("arrayIndex") !== undefined &&
            questionBankVOList[parseInt(e.target.getAttribute("arrayIndex"))]) {
            setCurrentQuestion(questionBankVOList[parseInt(e.target.getAttribute("arrayIndex"))]);
            getAttemptedIssueSpotting(questionBankVOList[parseInt(e.target.getAttribute("arrayIndex"))]);
            /*CC-5522 HS */
            var cques = questionBankVOList[parseInt(e.target.getAttribute("arrayIndex"))]
            setbtnFlagText(cques.questionResponseVO.flagged === "false" ? "Flag For Later" : "Flagged");
            if (questionBankVOList[parseInt(e.target.getAttribute("arrayIndex"))].questionResponseVO.status == "correct") {
                setpracticebtn(false);
                setincorrectbtn(false);
                setcorrectbtn(true);
            }
            else if (questionBankVOList[parseInt(e.target.getAttribute("arrayIndex"))].questionResponseVO.status == "incorrect") {
                setpracticebtn(false);
                setincorrectbtn(true);
                setcorrectbtn(false);
                setcorrectbtn(false);
            }
            else if (questionBankVOList[parseInt(e.target.getAttribute("arrayIndex"))].questionResponseVO.status == "partial") {
                setpracticebtn(true);
                setincorrectbtn(false);
                setcorrectbtn(false);
            }
            else {
                setpracticebtn(false);
                setincorrectbtn(false);
                setcorrectbtn(false);
            }
            updateCurrentQuestionBtn(parseInt(e.target.getAttribute("arrayIndex")) + 1, e.currentTarget.innerText);
            qList = [];
            subQList = [];
            let index = "";
            if (type === "next") {
                index = parseInt(e.target.getAttribute("arrayIndex")) + 1;
            }
            else {
                index = e.target.getAttribute("id") ? e.target.getAttribute("id").split('_')[1] : "";
            }
            for (let i = 0; i < globalData.length; i++) {
                globalData[i].currentQuestionFlag = "0";
            }
            let question = JSPath.apply('.{.questionNumber == "' + index + '"}', globalData)[0];
            question.currentQuestionFlag = "1";
            question.questionVO.subQuestionVOList.map((it, index) => {
                if (it.questionType === "order") {
                    setSubAnswerVOList(it.subAnswerVOList);
                }
                else if (it.questionType === "essay") {
                    setEssayText(it.questionText);
                    setGeneralFeedback(it.generalFeedback);
                }
            });
            // [HS]Issue Spotting - when the question is answred - dont show popover questions
            if (cques.questionResponseVO.attemptedAnswerVOList === undefined ||
                cques.questionResponseVO.attemptedAnswerVOList === null) {
                let issueToHighlight1 = $('#issueContainer span.issue').first();
                highlightIssue(issueToHighlight1);
            }
        }
    }
    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        return result;
    };
    const onDragEnd = (result) => {
        if (!result.destination) {
            return;
        }
        if (result.source.index === result.destination.index)
            return;
        const changedIssueOrder = reorder(
            subAnswerVOList,
            result.source.index,
            result.destination.index
        );
        changedIssueOrder.forEach((val, index) => { val.orderIndex = index + 1 });
        setSubAnswerVOList(changedIssueOrder);
    }
    const flagQuestion = (e) => {
        let reqData = {
            "userVO": {
                "userId": userVO.userId,
                "userActivityVO": {
                    "lastActivityCode": "BOOKSHELF",
                    "pageNavigatingFrom": "BOOKSHELF",
                    "pageNavigatingTo": "BOOKSHELF",
                },
                sessionVO: {
                    "appType": "web",
                    "browserName": localStorage.getItem('browserName'),
                    "deviceMacId": "",
                    "deviceOS": localStorage.getItem('deviceOS'),
                    "deviceType": localStorage.getItem('deviceType'),
                    "keepMeLoggedInFlag": keepMeLogIn,
                    "sessionAuthenticationToken": userVO.sessionAuthenticationToken,
                },
                "userRole": userVO.userRole,
                "userRoleId": userVO.userRoleId,
            },
            "assessmentVO": {
                "questionVO": {
                    "questionType": "issuespotting",
                    "questionId": currentQuestion.questionVO.questionId,
                    "flagValue": e.target.getAttribute("flagValue") === "true" ? "0" : "1"
                }
            }
        }
        const requestOptions1 = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(reqData)
        };
        fetch(localStorage.getItem('ENV') + "/manageAssessmentService/saveFlagUnflagStatus", requestOptions1)
            .then(response => response.json())
            .then(data => {
                if (data) {
                    if (data.status === "true") {
                        let currQuestion = currentQuestion;
                        currQuestion.questionResponseVO.flagged = e.target.getAttribute("flagValue") === "true" ? "false" : "true";
                        setCurrentQuestion(currQuestion);
                        setbtnFlagText(currQuestion.questionResponseVO.flagged === "false" ? "Flag For Later" : "Flagged");
                    } else {
                        if (data.wkErrorCode) {
                            handleException(data);
                        }
                    }
                }
            }).catch(error => {
                console.error("There has been a problem with your fetch operation:", error);
            });
    }
    const updateGradeIssueSpotting = (e) => {
        let grade = 0;
        if (e.target.getAttribute("myKnowledge") === "correct") {
            grade = 1;
            setpracticebtn(false);
            setincorrectbtn(false);
            setcorrectbtn(true);
        }
        else if (e.target.getAttribute("myKnowledge") === "incorrect") {
            grade = 0;
            setpracticebtn(false);
            setincorrectbtn(true);
            setcorrectbtn(false);
        }
        else if (e.target.getAttribute("myKnowledge") === "partial") {
            grade = 2;
            setpracticebtn(true);
            setincorrectbtn(false);
            setcorrectbtn(false);
        } else {
            setpracticebtn(false);
            setincorrectbtn(false);
            setcorrectbtn(false);
        }
        let currQuestion = currentQuestion
        let selectedOption, responseAns = "";
        if (currQuestion.questionResponseVO.attemptedAnswerVOList) {
            responseAns = currQuestion.questionResponseVO.attemptedAnswerVOList.responseText;
        }
        if (editorRef.current !== null && editorRef.current.getBody() !== null)
            responseAns = editorRef.current.getBody().innerHTML;
        let reqData = {
            "userVO": {
                "userId": userVO.userId,
                "userActivityVO": {
                    "lastActivityCode": "BOOKSHELF",
                    "pageNavigatingFrom": "BOOKSHELF",
                    "pageNavigatingTo": "BOOKSHELF",
                },
                sessionVO: {
                    "appType": "web",
                    "browserName": localStorage.getItem('browserName'),
                    "deviceMacId": "",
                    "deviceOS": localStorage.getItem('deviceOS'),
                    "deviceType": localStorage.getItem('deviceType'),
                    "keepMeLoggedInFlag": keepMeLogIn,
                    "sessionAuthenticationToken": userVO.sessionAuthenticationToken,
                },
                "userRole": userVO.userRole,
                "userRoleId": userVO.userRoleId,
            },
            "assessmentVO": {
                "questionVO": {
                    "grade": grade,
                    "optionNumber": "",
                    "questionType": "issuespotting",
                    "chapterId": props.match.params.chapterid,
                    "learningObjectId": props.match.params.loid,
                    "questionNumber": currentQuestion.questionNumber,
                    "answerVOList": [{ "responseText": responseAns }],
                    "questionId": currentQuestion.questionVO.questionId,
                }
            }
        }
        const requestOptions1 = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(reqData)
        };
        fetch(localStorage.getItem('ENV') + "/manageAssessmentService/saveQuestionResponse", requestOptions1)
            .then(response => response.json())
            .then(data => {
                if (data) {
                    if (data.status === "true") {
                        let btn = document.getElementById("btnQuestion_" + currentQuestion.questionNumber);
                        if (grade === 0) {
                            currQuestion.questionResponseVO.status = "incorrect";
                            btn.className = "numberBox redBgColor btn btn-primary";
                            setpracticebtn(false);
                            setincorrectbtn(true);
                            setcorrectbtn(false);
                        }
                        else if (grade === 1) {
                            currQuestion.questionResponseVO.status = "correct"
                            btn.className = "numberBox greenBgColor btn btn-primary";
                            setpracticebtn(false);
                            setincorrectbtn(false);
                            setcorrectbtn(true);
                        }
                        else if (grade === 2) {
                            currQuestion.questionResponseVO.status = "partial"
                            btn.className = "numberBox blueBgColor btn btn-primary";
                            setpracticebtn(true);
                            setincorrectbtn(false);
                            setcorrectbtn(false);
                        }
                        else {
                            setpracticebtn(false);
                            setincorrectbtn(false);
                            setcorrectbtn(false);
                        }
                        setCurrentQuestion(currQuestion);
                    } else if (data.wkErrorCode) {
                        handleException(data);
                    }
                }
            }).catch(error => {
                console.error("There has been a problem with your fetch operation:", error);
            });
    }
    const updateCurrentQuestionBtn = (questionNumber, btnName) => {
        document.querySelectorAll('.questionNumberBtn').forEach(x => {
            x.classList.remove("active-question-btn");
        });
        if (document.getElementById("btnQuestion_" + questionNumber - 1)) {
            document.getElementById("btnQuestion_" + questionNumber - 1).classList.remove("active-question-btn");
            document.getElementById("btnQuestion_" + questionNumber - 1).style.border = "inherit";
        }
        if (document.getElementById("btnQuestion_" + questionNumber + 1)) {
            document.getElementById("btnQuestion_" + questionNumber + 1).classList.remove("active-question-btn");
            document.getElementById("btnQuestion_" + questionNumber + 1).style.border = "inherit";
        }
        if (btnName === "Skip" || btnName === "Next") {
            if (document.getElementById("btnQuestion_" + questionNumber))
                document.getElementById("btnQuestion_" + questionNumber).classList.add("active-question-btn")
            document.querySelectorAll('.questionNumberBtn').forEach(x => x.style.border = "inherit")
        }
    }
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    const { items } = usePagination({
        count: totalQuestionCount,
        pageProp: questionBankVOList,
        boundaryCount: 2,
        onChange: (e) => getQuestion(e)
    });
    useEffect(() => {
        const fetchImgForCurrentQuestion = async () => {
            const currentQuestionImg = document.querySelector('img[src*="questionimages/"]');
            if (currentQuestionImg) {
                let relativeUrl = `/casebook/questionimages${currentQuestionImg.src.split('/questionimages')[1]}`;
                relativeUrl = relativeUrl.split('?')[0];
                let reqData = { "genericServiceRequestVO": { "inputBaseUrl": relativeUrl } };
                try {
                    const data = await (await post("/manageUrlService/getCDNUrl", reqData, "ENV")).json();
                    if (data.status === "true") {
                        currentQuestionImg.src = data.genericServiceResponseVO.cdnUrl;
                        currentQuestionImg.style.maxHeight = "250px";
                        currentQuestionImg.style.maxWidth = "100%";
                    } else if (data.wkErrorCode) {
                        handleException(data);
                    }
                } catch (error) {
                    console.error("There has been a problem with your fetch operation:", error);
                }
            }
        }
        fetchImgForCurrentQuestion();
    }, [currentQuestion]);
    const handleBackToStudyCenter = (e) => {
        if (e.key === "Enter") {
            navigateToStudyDashboard(e);
        }
    }
    return (
        <React.Fragment>
            <div className={classes.root}>
                <Spinner
                    loading={isloading}
                    imageSrc={loaderColors1}
                    overlayBackground="rgba(0,0,0,0.7)"
                    label="Loading issue spotting questions"
                />
                <Popper id={id} role='dialog' aria-label='Dialog Box for Selecting the Issue in Given Question' open={isPopoverOpen}
                    anchorEl={anchorEl} container={document.getElementById('issueContainer')} placement="bottom-start" disablePortal={false}
                    modifiers={{
                        flip: {
                            enabled: true,
                        },
                        preventOverflow: {
                            enabled: true,
                            boundariesElement: 'scrollParent'
                        },
                    }}
                    transition
                >
                    {({ TransitionProps }) => (
                        <Fade {...TransitionProps} timeout={350}>
                            <Paper>
                                <Typography>
                                    <div className="hlPopover" rel="popover" data-trigger="focus">
                                        <div className="issue_spotting" id="issue_spotting">
                                            <div className="issueSpottingContainer">
                                                <div className="highlight-popoverIssue" style={{ fontFamily: "Arial" }}>
                                                    <div id="popover-content">
                                                        <div className="issueText mt-2">{parse(issueText)}</div>
                                                        <div className="issueOptions">
                                                            {issueOptions.map((issueOption, index) => (
                                                                <div key={index} className="radio-custom radio-custom-unanswered">
                                                                    <div className="radio">
                                                                        <label className="align-top" style={{ float: 'left' }}>
                                                                            <input type="radio" aria-label={issueOption.answer ? issueOption.answer : ""} name="optionsRadios" id={'optionsRadios' + index} value={index}
                                                                                data-handler="issueSpotting.issueSpotSubmit" onClick={(e) => issueSpotSubmit(e)} />
                                                                        </label>
                                                                        <label className="align-top" style={{ width: '85%' }}>{numberToCharacterMap[index + 1] + '. ' + issueOption.answer}</label>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                        <div id="feedback" className="issueFeedback">{parse(issueFeedback)}</div>
                                                        {
                                                            issueNextBtn ?
                                                                <div className="pr-2 pb-1 issueNextBtn">
                                                                    <button type="button" id="nextBtn" value="Next" className="studyButton btn btn-secondary" onClick={(e) => handleNextClick(e)}>
                                                                        Next
                                                                    </button>
                                                                </div> : null
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Typography>
                            </Paper>
                        </Fade>
                    )}
                </Popper>
            </div>
            <Header userVO={userVO} bookVO={bookVO} pageName="study" ></Header>
            <StudyCenterHeader userVO={userVO} />
            <div className="col-lg-12">
                <div className="row greyDiv">
                    <div className="col-xl-8 col-lg-7 col-md-5 col-sm-12 col-xs-12 headingDiv">
                        <span className="insightProperty">{loName}</span><br />
                        <span className="insightHeading">Issue Spotting</span><br />
                        <span tabIndex="0" onKeyDown={(e) => handleBackToStudyCenter(e)}>
                            <a className="studyLink cusorPointer" onClick={(e) => navigateToStudyDashboard(e)}>Back to Study Center</a>
                        </span>
                    </div>
                    <div className="col-xl-4 col-lg-5 col-md-7 col-sm-12 col-xs-12" style={{ margin: 'auto' }}>
                        <ButtonToolbar aria-label="Toolbar with button groups" style={{ justifyContent: 'center' }}>
                            <ButtonGroup className="mr-2" aria-label="First group">
                                <ul className={classes.ul}>
                                    {items.map(({ page, type, selected, ...item }, index) => {
                                        let children = null;
                                        if (type === 'start-ellipsis' || type === 'end-ellipsis') {
                                            if (totalQuestionCount != "1" && parseInt(totalQuestionCount) > 6) {
                                                children = (<i style={{ margin: '15px 5px 0 0' }} className="fa fa-ellipsis-h" aria-hidden="true"></i>);
                                            }
                                        } else if (type === 'page') {
                                            if (questionBankVOList !== null && questionBankVOList !== undefined) {
                                                if (questionBankVOList[page - 1].questionResponseVO !== null && questionBankVOList[page - 1].questionResponseVO !== undefined) {
                                                    if (questionBankVOList[page - 1].questionResponseVO.status === "incorrect") {
                                                        children = (<span><button {...item} style={{ color: selected ? '#000000' : undefined, border: selected ? '1px solid #000' : undefined }} arrayIndex={page - 1} id={"btnQuestion_" + questionBankVOList[page - 1].questionNumber} aria-label={`View question ${questionBankVOList[page - 1].questionNumber}`} className="questionNumberBtn numberBox redBgColor">{page}</button> &nbsp;&nbsp; </span>)
                                                    }
                                                    else if (questionBankVOList[page - 1].questionResponseVO.status === "correct") {
                                                        children = (<span><button {...item} style={{ color: selected ? '#000000' : undefined, border: selected ? '1px solid #000' : undefined }} arrayIndex={page - 1} id={"btnQuestion_" + questionBankVOList[page - 1].questionNumber} aria-label={`View question ${questionBankVOList[page - 1].questionNumber}`} className="questionNumberBtn numberBox greenBgColor">{page}</button>&nbsp;&nbsp; </span>)
                                                    }
                                                    else if (questionBankVOList[page - 1].questionResponseVO.status === "partial") {
                                                        children = (<span><button {...item} style={{ color: selected ? '#000000' : undefined, border: selected ? '1px solid #000' : undefined }} arrayIndex={page - 1} id={"btnQuestion_" + questionBankVOList[page - 1].questionNumber} aria-label={`View question ${questionBankVOList[page - 1].questionNumber}`} className="questionNumberBtn numberBox blueBgColor">{page}</button>&nbsp;&nbsp; </span>)
                                                    }
                                                    else {
                                                        children = (<span><button {...item} style={{ color: selected ? '#007AC3' : undefined, border: selected ? '1px solid #000' : undefined }} arrayIndex={page - 1} id={"btnQuestion_" + questionBankVOList[page - 1].questionNumber} aria-label={`View question ${questionBankVOList[page - 1].questionNumber}`} className="questionNumberBtn numberBox">{page}</button>&nbsp;&nbsp; </span>)
                                                    }
                                                }
                                            }
                                        }
                                        return <li key={index}>{children}</li>;
                                    })}
                                </ul>
                            </ButtonGroup>
                        </ButtonToolbar>
                    </div>
                </div>
                <div className="row">
                    <div className="studyDiv">
                        <div className="col-lg-12">
                            {
                                (
                                    currentQuestion && currentQuestion.questionVO.studyAidVOList && !Array.isArray(currentQuestion.questionVO.studyAidVOList)
                                    && currentQuestion.questionVO.studyAidVOList.studyAidTitle && currentQuestion.questionVO.studyAidVOList.studyAidLink
                                ) ?
                                    <span>From
                                        <span className="studyLink">
                                            &nbsp; <a href={currentQuestion.questionVO.studyAidVOList.studyAidLink} target="__blank">
                                                {currentQuestion.questionVO.studyAidVOList.studyAidTitle}
                                            </a>
                                        </span>
                                    </span> : null
                            }
                            <div className="insightProperty mb-3">Step 1: Find the Issues</div>
                            {currentQuestion !== null ?
                                <div className="issueContainer" id="issueContainer">
                                    <span className="insightProperty" style={{ fontFamily: "Arial" }}>{currentQuestion.questionVO !== null ? parse(currentQuestion.questionVO.questionText) : ""}</span>
                                </div> : null
                            }
                            {
                                issueOrder ?
                                    <div className="insightProperty mb-3">Step 2: Arrange the Issues</div> : null
                            }
                            <div id="issueOrder" style={{ fontFamily: "Arial" }}>
                                <DragDropContext draggable="false" onDragEnd={onDragEnd}>
                                    <Droppable droppableId="droppable">
                                        {(droppableProvided, droppableSnapshot) => (
                                            <ul className="labelVOList" style={{ listStyleType: "none", padding: "0" }}
                                                ref={droppableProvided.innerRef}
                                                {...droppableProvided.droppableProps}
                                            >
                                                {issueOrder ?
                                                    subAnswerVOList !== null ?
                                                        subAnswerVOList.map((item, index) => {
                                                            return <Draggable key={"issueOrder_" + index} draggableId={"issueOrder_" + index} index={index}>
                                                                {(draggableProvided, draggableSnapshot) => (
                                                                    <div
                                                                        ref={draggableProvided.innerRef}
                                                                        {...draggableProvided.draggableProps}
                                                                        {...draggableProvided.dragHandleProps}
                                                                    >
                                                                        <li className="shortanswerht studyissues" key={index} issueId={item.issueId} correctOrder={item.correctOrder}><BiMove className="dragDropIcon mRightFive" /> {item.issueText}</li>
                                                                    </div>
                                                                )}
                                                            </Draggable>
                                                        })
                                                        : null
                                                    : null
                                                }
                                            </ul>
                                        )}
                                    </Droppable>
                                </DragDropContext>
                            </div>
                            {
                                issueEssay ?
                                    <div className="insightProperty mb-3">Step 3: Write the Essay</div> : null
                            }
                            {issueEssay ?
                                essayText !== null ?
                                    <div className="studymar">{parse(essayText)}</div> : null
                                : null
                            }
                            {issueEssay ?
                                <div className="" id="studySAEditorId">
                                    <Editor
                                        onInit={(evt, editor) => editorRef.current = editor}
                                        apiKey="0pf9aw3is77mhjeluerke3yzvxj13f9yocjczeumortsxfg5"
                                        init={{
                                            selector: "textarea",
                                            theme: 'silver',
                                            mobile: {
                                                theme: 'mobile',
                                                plugins: 'autosave lists autolink',
                                                toolbar: ['undo', 'redo', 'bold', 'italic', 'bullist', 'numlist', 'outdent', 'indent', 'styleselect']
                                            },
                                            plugins: "lists fullscreen template directionality noneditable advlist nonbreaking",
                                            toolbar1: "undo redo | fontselect fontsizeselect | bold italic underline | alignleft aligncenter alignright alignjustify | sectionButton | bullist numlist | outdent indent | forecolor backcolor | removeHighlight",
                                            menubar: false,
                                            directionality: "ltr",
                                            toolbar_items_size: 'medium',
                                            extended_valid_elements: "a[href|onclick]",
                                            fontsize_formats: "10px 12px 14px 18px 24px 36px 48px 64px",
                                            font_formats: "Andale Mono=andale mono,times;" + "Arial=arial,helvetica,sans-serif;" + "Arial Black=arial black,avant garde;" + "Book Antiqua=book antiqua,palatino;" + "Comic Sans MS=comic sans ms,sans-serif;" + "Courier New=courier new,courier;" + "Georgia=georgia,palatino;" + "Helvetica=helvetica;" + "Impact=impact,chicago",
                                            entity_encoding: "named",
                                            resize: "true",
                                            statusbar: false,
                                            height: 250,
                                            marginBottom: 10,
                                            paddingleft: 10,
                                            marginLeft: 50,
                                            nonbreaking_force_tab: false,
                                            toolbar: "ltr rtl  bullist numlist",
                                            forced_root_block: 'p',
                                            force_br_newlines: false,
                                            force_p_newlines: true,
                                            paste_auto_cleanup_on_paste: false,
                                            theme_advanced_resizing: true,
                                            theme_advanced_resize_horizontal: false
                                        }}
                                        onChange={() => handleEditorChange()}
                                        initialValue={issueSpotTiny}
                                        onBlur={(e) => submitAnswerShortAnswer(e, "save")}
                                    />
                                </div> : null
                            }
                            {showissueEssay ?
                                <div>
                                    <div className="insightProperty mb-3">Step 3: Write the Essay</div>
                                    <div className="showissueEssay" id="showissueEssay">
                                        <span className="showissueEssay1">{parse(essayAnswer)}</span>
                                    </div>
                                    <div className="mt-4">
                                        <div className="insightProperty mb-3"><b>Model Answer</b></div>
                                        <span style={{ fontFamily: "Arial" }}>{parse(generalFeedback)}</span>
                                    </div>
                                </div>
                                : null}
                            <br></br>
                            {
                                showSubmitBtn ?
                                    <Button id="issueSubmit" className="studyButton" onClick={(e) => submitAnswerShortAnswer(e, "submit")}>Submit</Button>
                                    : null
                            }
                            <hr />
                            {currentQuestion !== null ?
                                <div className="myKnowledgeSection">
                                    <div className="rightSideButtonSet">
                                        {totalQuestionCount !== currentQuestion.questionNumber ?
                                            <Button className="myKnowledgeSectionButton studyButton" aria-label="Next question" arrayIndex={currentQuestion.questionNumber} id={"next_" + currentQuestion.questionNumber} onClick={(e) => getQuestion(e, "next")}>Next</Button> : null}
                                        <Button id="btnflag" variant="outline-secondary" aria-label={currentQuestion.questionResponseVO.flagged == 'false' ? "Flag this question for later" : "Unflag this question"} aria-pressed={currentQuestion.questionResponseVO.flagged} flagValue={currentQuestion.questionResponseVO.flagged} onClick={(e) => flagQuestion(e)} className="myKnowledgeSectionButton studyButton nextStudy">
                                            {btnFlagText}
                                        </Button>
                                    </div>
                                    <div className="leftSideButtonSet">
                                        <div className="textHead">My knowledge on this question is:</div>
                                        {correctbtn == true ?
                                            <Button aria-selected="true" aria-label="My knowledge on this question is: Correct" className="myKnowledgeSectionButton correctprimaryactive" myKnowledge="correct" onClick={(e) => updateGradeIssueSpotting(e)} >Correct</Button>
                                            :
                                            <Button aria-selected="false" aria-label="My knowledge on this question is: Correct" className="myKnowledgeSectionButton studyButton correctprimary" myKnowledge="correct" onClick={(e) => updateGradeIssueSpotting(e)} >Correct</Button>
                                        }
                                        {incorrectbtn == true ?
                                            <Button aria-selected="true" aria-label="My knowledge on this question is: Incorrect" className="myKnowledgeSectionButton incorrectprimaryactive ml-3" myKnowledge="incorrect" onClick={(e) => updateGradeIssueSpotting(e)} >Incorrect</Button>
                                            :
                                            <Button aria-selected="false" aria-label="My knowledge on this question is: Incorrect" className="myKnowledgeSectionButton studyButton incorrectprimary ml-3" myKnowledge="incorrect" onClick={(e) => updateGradeIssueSpotting(e)} >Incorrect</Button>
                                        }
                                        {practicebtn == true ?
                                            <Button aria-selected="true" aria-label="My knowledge on this question is: Needs Practice" className="myKnowledgeSectionButton needsmoreactive ml-3" myKnowledge="partial" onClick={(e) => updateGradeIssueSpotting(e)} >Needs Practice</Button>
                                            :
                                            <Button aria-selected="false" aria-label="My knowledge on this question is: Needs Practice" className="myKnowledgeSectionButton studyButton needsmore ml-3" myKnowledge="partial" onClick={(e) => updateGradeIssueSpotting(e)} >Needs Practice</Button>
                                        }
                                    </div>
                                </div>
                                : null}
                        </div>
                        <br /><br />
                        <div>
                            <span className="insightHeading">
                                About the Connected eBook Study Center
                            </span>
                            <br /> <br />
                            <span className="insightProperty">
                                The content in the Study Center is selected and maintained exclusively by Aspen Publishing and a team of professor reviewers and editors, not by the authors of your book. These materials typically come from one or more of Aspen Publishing's top study aids, including Examples & Explanations, Glannon Guides, Emanuel Law Outlines, and Emanuel Law in a Flash, or may be created with assistance from AI tools. Study material sources and activity types vary depending on availability for any given chapter, topic, or course.
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </React.Fragment>
    );
}
export default withAuth(withRouter(StudyIssueSpotStudent));